import { type IDropdownItem } from 'shared/ui'
import { type IUser } from 'entities/Users'

export const userToDropdownItem = (item: IUser): IDropdownItem => ({
  id: item.id,
  label: item.name,
  value: item.name,
  data: item,
  avatarProps: {
    online: !item.isAway,
    size: 16,
    info: item.avatarInfo,
  },
})
